import {
  createFrontendPlugin,
  PageBlueprint,
  ApiBlueprint,
  createFrontendFeatureLoader,
} from '@backstage/frontend-plugin-api';
import {
  discoveryApiRef,
  fetchApiRef,
  microsoftAuthApiRef,
  configApiRef,
} from '@backstage/core-plugin-api';
import PolicyIcon from '@material-ui/icons/Policy';
import { rootRouteRef } from '../routes';
import { azurePolicyApiRef, AzurePolicyClient } from '../api';

export { NfsAzurePolicyOverview as AzurePolicyOverview } from '../components/AzurePolicyOverview';

const azPolicyPage = PageBlueprint.make({
  params: {
    path: '/az-policy',
    title: 'Azure Policy',
    icon: <PolicyIcon />,
    routeRef: rootRouteRef,
    loader: () =>
      import('../components/AzurePolicyOverview').then(m => (
        <m.NfsAzurePolicyOverview />
      )),
  },
});

const azurePolicyApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: azurePolicyApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        microsoftAuthApi: microsoftAuthApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, fetchApi, microsoftAuthApi, configApi }) =>
        new AzurePolicyClient({
          discoveryApi,
          fetchApi,
          microsoftAuthApi,
          config: configApi,
        }),
    }),
});

const internalPlugin = createFrontendPlugin({
  pluginId: 'az-policy',
  info: {
    packageJson: () => import('../../package.json'),
  },
  featureFlags: [
    {
      name: 'az-policy-enabled',
      description: 'Enable Azure Policy plugin',
    },
  ],
  if: { featureFlags: { $contains: 'az-policy-enabled' } },
  routes: {
    root: rootRouteRef,
  },
  extensions: [azPolicyPage, azurePolicyApi],
});

/** @alpha */
export default createFrontendFeatureLoader({
  async *loader({ config }) {
    if (config.getOptionalBoolean('platt.azurePolicy.enabled')) {
      yield internalPlugin;
    }
  },
});
